import type { McpTool } from "@p0security/shared/types/agentic/mcp";

// Generated from the servicenow image's endpoint table (agentic-gateway
// `docker/servicenow`, `yarn generate:catalog`); regenerate rather than edit. A
// module rather than the JSON itself because the frontend's esbuild cannot
// parse a JSON import attribute.
export const serviceNowAiMcpTools: McpTool[] = [
  {
    name: "query_records",
    description:
      "Find records in a table with an encoded query. ServiceNow returns only the records and fields the agent's roles may read; a record it may not read is absent, not an error. Use describe_table to find a table's fields.",
    inputSchema: {
      type: "object",
      properties: {
        table: {
          type: "string",
          description:
            "Table name, e.g. incident, change_request, sc_req_item, sys_user",
        },
        query: {
          type: "string",
          description:
            "Encoded query, e.g. active=true^priority=1^ORDERBYDESCsys_created_on",
        },
        fields: {
          type: "string",
          description:
            "Comma-separated fields to return, e.g. number,short_description,state. Omit for every field the user may read.",
        },
        limit: {
          type: "integer",
          description: "Maximum records to return (default 20)",
        },
        offset: {
          type: "integer",
          description: "Number of records to skip, for paging",
        },
        display_value: {
          type: "string",
          enum: ["false", "true", "all"],
          description:
            "false gives stored values (sys_ids for references), true gives display values, all gives both",
        },
      },
      required: ["table"],
    },
    annotations: {
      readOnlyHint: true,
      openWorldHint: true,
    },
  },
  {
    name: "get_record",
    description:
      "Get one record by its sys_id. ServiceNow answers 404 for a record that does not exist and for one the agent's roles may not read.",
    inputSchema: {
      type: "object",
      properties: {
        table: {
          type: "string",
          description:
            "Table name, e.g. incident, change_request, sc_req_item, sys_user",
        },
        sys_id: {
          type: "string",
          description: "The record's sys_id (32 hexadecimal characters)",
        },
        fields: {
          type: "string",
          description:
            "Comma-separated fields to return, e.g. number,short_description,state. Omit for every field the user may read.",
        },
        display_value: {
          type: "string",
          enum: ["false", "true", "all"],
          description:
            "false gives stored values (sys_ids for references), true gives display values, all gives both",
        },
      },
      required: ["table", "sys_id"],
    },
    annotations: {
      readOnlyHint: true,
      openWorldHint: true,
    },
  },
  {
    name: "describe_table",
    description:
      "List a table's fields, inherited fields included: name, label, type, whether it is mandatory or read-only, and the table a reference field points to.",
    inputSchema: {
      type: "object",
      properties: {
        table: {
          type: "string",
          description:
            "Table name, e.g. incident, change_request, sc_req_item, sys_user",
        },
      },
      required: ["table"],
    },
    annotations: {
      readOnlyHint: true,
      openWorldHint: true,
    },
  },
  {
    name: "create_record",
    description:
      "Create a record in a table. ServiceNow answers 403 when the agent's roles may not create in the table, and ignores fields the roles may not write.",
    inputSchema: {
      type: "object",
      properties: {
        table: {
          type: "string",
          description:
            "Table name, e.g. incident, change_request, sc_req_item, sys_user",
        },
        fields: {
          type: "string",
          description:
            "Comma-separated fields to return, e.g. number,short_description,state. Omit for every field the user may read.",
        },
        values: {
          type: "object",
          description:
            'Field names and the values to set, e.g. {"short_description": "...", "urgency": "2"}',
        },
      },
      required: ["table", "values"],
    },
    annotations: {
      readOnlyHint: false,
      destructiveHint: false,
      openWorldHint: true,
    },
  },
  {
    name: "update_record",
    description:
      "Change fields of one record. Only the given fields change. ServiceNow answers 403 when the agent's roles may not write the record.",
    inputSchema: {
      type: "object",
      properties: {
        table: {
          type: "string",
          description:
            "Table name, e.g. incident, change_request, sc_req_item, sys_user",
        },
        sys_id: {
          type: "string",
          description: "The record's sys_id (32 hexadecimal characters)",
        },
        fields: {
          type: "string",
          description:
            "Comma-separated fields to return, e.g. number,short_description,state. Omit for every field the user may read.",
        },
        values: {
          type: "object",
          description:
            'Field names and the values to set, e.g. {"short_description": "...", "urgency": "2"}',
        },
      },
      required: ["table", "sys_id", "values"],
    },
    annotations: {
      readOnlyHint: false,
      destructiveHint: true,
      idempotentHint: true,
      openWorldHint: true,
    },
  },
];
